webpackJsonp([19],{

/***/ "3NEH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"site-footer",attrs:{"id":"colophon"}},[_c('div',{staticClass:"inner"},[_c('div',{staticClass:"content"},[_c('p',{staticClass:"title"},[_vm._v("Look what you’ve unearthed")]),_vm._v(" "),_c('ul',{staticClass:"footer-objects"},[_c('li',[_c('div',{staticClass:"object square"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"content-front object-weather",class:_vm.weather.currentCondition}),_vm._v(" "),_c('div',{staticClass:"content-back"},[_c('p',[_vm._v("Here in Derby")]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(Math.floor(_vm.weather.main.temp - 273.15))+"°")]),_vm._v(" "),(_vm.weather.weather[0])?_c('p',[_vm._v("and there's "+_vm._s(_vm.weather.weather[0].description)+"!")]):_vm._e()])])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"object square"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"content-front object-strava",class:{'office-open': _vm.open}}),_vm._v(" "),_c('div',{staticClass:"content-back"},[(_vm.open)?_c('p',[_vm._v("We're open today from 9am - 5:30pm")]):_c('p',[_vm._v("We're closed but will be open soon!")])])])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"object circle"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"content-front object-drinks",class:_vm.timeClass}),_vm._v(" "),_c('div',{staticClass:"content-back"},[(_vm.timeClass == 'soon')?_c('p',[_vm._v(_vm._s(_vm.timeLeft))]):_c('p',[_vm._v("Gone T' Pub!")])])])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"object square"},[_c('div',{staticClass:"content"},[(_vm.currentlyListening.image[3])?_c('div',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(_vm.currentlyListening.image[3]['#text']  || '/album-art.png'),expression:"currentlyListening.image[3]['#text']  || '/album-art.png'",arg:"background-image"}],staticClass:"content-front object-music"}):_c('div',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:('/album-art.png'),expression:"'/album-art.png'",arg:"background-image"}]}),_vm._v(" "),_c('div',{staticClass:"content-back"},[_vm._m(0),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.currentlyListening.artist['#text'])),_c('br'),_vm._v(_vm._s(_vm.currentlyListening.name))])])])])])]),_vm._v(" "),_c('a',{staticClass:"back-to-top",on:{"click":_vm.scrollToTop}},[_c('strong',[_vm._v("↑")]),_vm._v(" Back to Top")]),_vm._v(" "),_c('div',{staticClass:"footer-collaterals"},[_c('div',[_c('p',{staticClass:"handmade"},[_vm._v("© Alt Design "+_vm._s(_vm.year)+"  Company Reg: 4682630  "),_c('router-link',{attrs:{"to":"/cookie-policy"}},[_vm._v("Privacy & Cookie Policy")])],1)]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Now Playing")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"handmade"},[_vm._v("Handmade in Derbyshire")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"address handmade"},[_vm._v("Thorncliffe House, 278 Uttoxeter New Rd, Derby DE22 3LN")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8SNN":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("oxNK");
module.exports = __webpack_require__("kQRy").Object.entries;

/***/ }),

/***/ "Dl99":
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__("I0PI")
  , ITERATOR  = __webpack_require__("3mw8")('iterator')
  , Iterators = __webpack_require__("JBE3");
module.exports = __webpack_require__("kQRy").isIterable = function(it){
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    || Iterators.hasOwnProperty(classof(O));
};

/***/ }),

/***/ "VdBz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__("cQYP");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09be835c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__("3NEH");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09be835c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "W3Iv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("8SNN"), __esModule: true };

/***/ }),

/***/ "cQYP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jump_js__ = __webpack_require__("q7+D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_countdown_js__ = __webpack_require__("jcOj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_countdown_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_countdown_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import CryptoJS from 'crypto-js'

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      timeLeft: '',
      timeClass: '',
      currentlyListening: {
        track: '',
        artist: '',
        image: []
      },
      weather: {
        temp: '',
        currentCondition: '',
        conditions: '',
        main: { temp: 0 },
        weather: [{ description: '' }]
      },
      scrollParts: {},
      open: true,
      year: 2017
    };
  },

  methods: {
    // Scroll to top button
    scrollToTop: function scrollToTop() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_jump_js__["a" /* default */])('html', { duration: 500 });
    },

    // Sets the margin for the scrolling of the bottom
    setFooterMargin: function setFooterMargin() {
      if (document.documentElement.clientWidth > 1024) {
        document.querySelector('.site-content').style.marginBottom = document.querySelector('.site-footer').offsetHeight + 'px';
      }
    },

    // Handles the triggering of the footer objects.
    handleTrigger: function handleTrigger() {
      var _this = this;

      // Check current scroll
      var scrollTop = window.pageYOffset;
      var trigger = document.body.scrollHeight - this.scrollParts.colophonInfo.height;

      // Do we need this to be displayed?
      this.scrollParts.header.style.display = scrollTop + this.scrollParts.offset > trigger ? 'none' : 'block';

      // If we've scrolled far enough. Kill it if not - or if it has already triggered.
      if (!this.scrollParts.triggered && scrollTop + this.scrollParts.offset > trigger) {
        (function () {
          // Let's stop further triggers
          _this.scrollParts.triggered = true;
          var footerObjects = document.querySelectorAll('.footer-objects .object');

          // Loop through the objects, do a simple rollover.

          var _loop = function _loop(index) {
            // Check's if this is an actual object
            if (footerObjects[index].classList) {
              // Roll in
              setTimeout(function () {
                footerObjects[index].classList.toggle('hover');
              }, 150 * index);
              // Roll out (Geodude)
              setTimeout(function () {
                footerObjects[index].classList.toggle('hover');
              }, 750 + 150 * index);
            }
          };

          for (var index in footerObjects) {
            _loop(index);
          }
        })();
      }
    },

    // Defaults our scrolly parts.
    setupParts: function setupParts() {
      this.scrollParts = {
        header: document.querySelector('header'),
        colophonInfo: document.getElementById('colophon').getBoundingClientRect(),
        offset: document.getElementById('colophon').getBoundingClientRect().height / 4 * 3,
        triggered: false
      };
      window.addEventListener('scroll', this.handleTrigger);
    },

    // Adds text to the beer time string
    addToTimeString: function addToTimeString(string, time, item) {
      // Prep part for object propertu
      var part = item + 's';
      if (time[part]) {
        // If it exists, add it to the time string
        string += time[part] + ' ' + item + (time[part] > 1 ? 's' : '') + ' ';
      }

      return string;
    },

    // Returns the time string for beer countdown
    getTimeString: function getTimeString(t) {
      // Setup Variables
      var returnString = 'Only ';
      var parts = ['day', 'hour', 'minute', 'second'];

      // Loop through the parts, add to the strings
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(parts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var part = _step.value;

          returnString = this.addToTimeString(returnString, t, part);
        }

        // Return the String
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return returnString + ' until Friday drinky poos!';
    },

    // Performs the calculations for the TTB
    beerTimer: function beerTimer() {
      var _this2 = this;

      // Setup the dates
      var beers = new Date();
      var now = new Date();
      beers.setDate(now.getDate() + (12 - now.getDay()) % 7);
      beers.setHours(16, 30, 0);

      // Perform the countdown
      __WEBPACK_IMPORTED_MODULE_4_countdown_js___default.a.timer(beers, function (t) {
        // Before the time
        _this2.timeLeft = _this2.getTimeString(t);
        _this2.timeClass = 'soon';
      }, function () {
        // After the time
        _this2.timeClass = 'now';
      });
    },

    // What are we playing right now?
    nowPlaying: function nowPlaying() {
      var _this3 = this;

      // Setup our API url
      var lastfmURL = 'https://ws.audioscrobbler.com/2.0/?method=user.getrecenttracks&user=alt-design&api_key=544769f69c31f6a0d20b0ddd18f83c54&limit=1&format=json';

      // Perform the GET request
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(lastfmURL).then(function (response) {
        // Set the currently Listening
        _this3.currentlyListening = response.data.recenttracks.track[0];
      });
    },

    // Gets the current weather from the Yahoo API
    derpWeather: function derpWeather() {
      this.weather.temp = '5';
      this.weather.currentCondition = 'rain';
      this.weather.text = 'raining';
      return true;
    },
    currentWeather: function currentWeather() {
      var _this4 = this;

      // Setup our API url
      // let weatherURL = 'https://query.yahooapis.com/v1/public/yql?q=select%20item.condition%20from%20weather.forecast%20where%20woeid%20%3D%2018114%20and%20u%20%3D%20\'c\'&format=json&env=store%3A%2F%2Fdatatables.org%2Falltableswithkeys'

      //         var url = 'https://weather-ydn-yql.media.yahoo.com/forecastrss'
      //         var method = 'GET'
      //         // var appId = 'HqPRxm7k'
      //         var consumerKey = 'dj0yJmk9Q21WMHZpd0RuWGVhJnM9Y29uc3VtZXJzZWNyZXQmc3Y9MCZ4PWYw'
      //         var consumerSecret = '55baa5f1ae5bfa275835877a55346ef6040dc898'
      //         var concat = '&'
      //         var query = {'location': 'derby, uk', 'format': 'json'}
      //         var oauth = {
      //           'oauth_consumer_key': consumerKey,
      //           'oauth_nonce': Math.random().toString(36).substring(2),
      //           'oauth_signature_method': 'HMAC-SHA1',
      //           'oauth_timestamp': parseInt(new Date().getTime() / 1000).toString(),
      //           'oauth_version': '1.0'
      //         }
      //
      //         var merged = {...query, ...oauth}
      //
      // // Note the sorting here is required
      //         var mergedArr = Object.keys(merged).sort().map(function (k) {
      //           return [k + '=' + encodeURIComponent(merged[k])]
      //         })
      //         var signatureBaseStr = method +
      //           concat + encodeURIComponent(url) +
      //           concat + encodeURIComponent(mergedArr.join(concat))
      //
      //         var compositeKey = encodeURIComponent(consumerSecret) + concat
      //         var hash = CryptoJS.HmacSHA1(signatureBaseStr, compositeKey)
      //         var signature = hash.toString(CryptoJS.enc.Base64)
      //
      //         oauth['oauth_signature'] = signature
      // var authHeader = 'OAuth ' + Object.keys(oauth).map(function (k) {
      //   return [k + '="' + oauth[k] + '"']
      // }).join(',')

      // Perform the GET request
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('https://api.openweathermap.org/data/2.5/weather?q=Derby,Derbyshire,GB&appid=a582955bc678f1f781359597f869ad62').then(function (weatherResponse) {
        // Set our weather object
        _this4.weather = weatherResponse.data;

        // Setup the potential conditions https://developer.yahoo.com/weather/documentation.html
        var conditions = {
          'sun': [701, 711, 721, 731, 741, 751, 761, 762, 771, 781, 800],
          'wind': [],
          'rain': [300, 301, 302, 310, 311, 312, 313, 314, 321, 500, 501, 502, 503, 504, 511, 520, 521, 522, 531],
          'thunder': [200, 201, 202, 210, 211, 212, 221, 230, 231, 232],
          'snow': [600, 601, 602, 611, 612, 613, 615, 616, 620, 621, 622]

          // Default to Clouds
        };_this4.weather.currentCondition = 'clouds';

        // Loop through the conditions find the correct one
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(conditions)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _ref = _step2.value;

            var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

            var key = _ref2[0];
            var items = _ref2[1];

            if (items.includes(_this4.weather.weather[0].id)) {
              _this4.weather.currentCondition = key;
              break;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      });
    },

    // Works out if we're open
    openingTimes: function openingTimes() {
      var d = new Date();
      var n = d.getDay();
      var now = d.getHours() + '.' + d.getMinutes();
      var weekdays = [['Sunday'], ['Monday', 9.00, 17.30], ['Tuesday', 9.00, 17.30], ['Wednesday', 9.00, 17.30], ['Thursday', 9.00, 17.30], ['Friday', 9.00, 17.30], ['Saturday'] // we are closed, sorry!
      ];
      var day = weekdays[n];

      this.open = now > day[1] && now < day[2] || now > day[3] && now < day[4];
    }
  },
  // Do these as early as possible
  created: function created() {
    this.nowPlaying();
    this.currentWeather();
    this.beerTimer();
  },

  // Do these when the DOM is ready
  mounted: function mounted() {
    this.setupParts();
    this.setFooterMargin();
    this.openingTimes();

    var d = new Date();
    this.year = d.getFullYear();

    window.addEventListener('resize', this.setFooterMargin);
  }
});

/***/ }),

/***/ "d7EF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__("us/S");

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__("BO1k");

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ "jcOj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Countdown = function(){}

Countdown.timer = function(end, onTick, onComplete) {
  var timeLeft = end - new Date();

  var timeAPI = {
    DAYS: 1000 * 60 * 60 * 24,
    HOURS: 1000 * 60 * 60,
    MINUTES: 1000 * 60,
    SECONDS: 1000
  }

  var tick = function() {
    if(timeLeft > 0) {
      var time = timeLeft
      var days = Math.floor(time / (timeAPI.DAYS))
      time %= timeAPI.DAYS
      var hours = Math.floor(time / (timeAPI.HOURS))
      time %= timeAPI.HOURS
      var minutes = Math.floor(time / (timeAPI.MINUTES))
      time %= timeAPI.MINUTES
      var seconds = Math.floor(time / (timeAPI.SECONDS))

      var countdown = {
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds
      }
      onTick(countdown)
      timeLeft -= 1000
    }else {
      timeLeft -= 1000
      clearInterval(interval),
      onComplete()
    }
  }

  var interval = setInterval(
    (function(self){
      return function(){
        tick.call(self)
      }
    })(this), 1000
  )

  var getTimeRemaining = function() {
      var time = timeLeft
      var days = Math.floor(time / timeAPI.DAYS)
      time %= timeAPI.DAYS
      var hours = Math.floor(time / timeAPI.HOURS)
      time %= timeAPI.HOURS
      var minutes = Math.floor(time / timeAPI.MINUTES)
      time %= timeAPI.MINUTES
      var seconds = Math.floor(time / timeAPI.SECONDS)

      return {
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds
      }
    }

  tick.call(this)

  return {
    abort: function() {
      clearInterval(interval)
    },
    getTimeRemaining: getTimeRemaining
  }
}

module.exports = Countdown;


/***/ }),

/***/ "l3mU":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("+3lO");
__webpack_require__("tz60");
module.exports = __webpack_require__("Dl99");

/***/ }),

/***/ "oxNK":
/***/ (function(module, exports, __webpack_require__) {

// http://goo.gl/XkBrjD
var $export  = __webpack_require__("afKD")
  , $entries = __webpack_require__("s1+l")(true);

$export($export.S, 'Object', {
  entries: function entries(it){
    return $entries(it);
  }
});

/***/ }),

/***/ "s1+l":
/***/ (function(module, exports, __webpack_require__) {

var $         = __webpack_require__("tvjU")
  , toIObject = __webpack_require__("hWNx")
  , isEnum    = $.isEnum;
module.exports = function(isEntries){
  return function(it){
    var O      = toIObject(it)
      , keys   = $.getKeys(O)
      , length = keys.length
      , i      = 0
      , result = []
      , key;
    while(length > i)if(isEnum.call(O, key = keys[i++])){
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};

/***/ }),

/***/ "us/S":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("l3mU"), __esModule: true };

/***/ })

});


// WEBPACK FOOTER //
// static/js/19.0c57d10e8768fffa7b49.js